import { FC, ReactNode } from 'react';
import classnames from 'classnames';
import { RadioGroup, Form } from 'rsuite';
import styles from './basicRadio.module.scss';
import { RadioCell } from './RadioCell';

interface BasicDataType {
  value: string;
  label: ReactNode;
  disabled?: boolean;
  hint?: string;
}

interface RsBasicRaioProps {
  data: BasicDataType[];
  selected: string;
  onChange: (s: string) => void;
  className?: string;
  inline?: boolean;
  disabled?: boolean;
}

export const RsBasicRaio: FC<RsBasicRaioProps> = ({
  data = [],
  selected = '',
  onChange = () => undefined,
  className = '',
  inline = false,
  disabled = false,
}) => {
  const handleChange = (v) => {
    onChange(v);
  };

  return (
    <RadioGroup
      value={selected}
      onChange={handleChange}
      className={classnames(styles.RsBasicRaioGroup, className)}
      disabled={disabled}
      inline={inline}
    >
      {data.map(({ value, label, disabled, hint }) => (
        <RadioCell
          key={value}
          value={value}
          label={label}
          disabled={disabled}
          customBottom={hint ? <Form.HelpText>{hint}</Form.HelpText> : <span />}
        />
      ))}
    </RadioGroup>
  );
};
